import { useEffect } from 'react';
import { Text, Box, Button } from '@chakra-ui/react';
import { DashboardSection } from '../../components/DashboardStyles';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function CreateStore() {
    const navigate = useNavigate();
    const storeReducer = useSelector((state) => state.storeReducer);
    const { store } = storeReducer;

    useEffect(() => {
        if (store) navigate('/dashboard/store');
    }, [navigate, store]);

    return (
        <DashboardSection>
            <Box
                maxWidth={{
                    base: '100%',
                    sm: '80%',
                    md: '60%',
                    lg: '60%',
                    xl: '80%',
                }}
                display="flex"
                flexDirection="column"
                gap="2rem">
                <Text
                    width="100%"
                    fontWeight="400"
                    fontSize={{
                        base: '0.875rem',
                        sm: '1rem',
                        md: '1.2rem',
                        lg: '1.225rem',
                        xl: '1.25rem',
                    }}>
                    Setup your Obana store in 3 easy steps and start selling right from your
                    dashboard
                </Text>
                <Button
                    maxWidth="8rem"
                    fontSize="xs"
                    background="#1b3b5f"
                    color="#ffffff"
                    onClick={() => navigate('/dashboard/store/create-a-store/form')}>
                    Create a store
                </Button>
            </Box>
        </DashboardSection>
    );
}
